function createKey(keyLength) {
  let key = '';
  let characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  let charactersLength = characters.length;

  for (let i = 0; i < keyLength; i++) {
    key += characters.substr(
      Math.floor(Math.random() * charactersLength + 1),
      1
    );
  }
  return 'random_hidden_key_' + key;
}

export default createKey;